// borrowed from https://stash.aexp.com/stash/projects/ONE/repos/axp-intranet-identity/browse/src/utils/issueRedirect.js
import url from 'url';

const redirect = (redirectUrl, replace) => {
  if (global.BROWSER) {
    window.location.replace(redirectUrl);
  } else {
    const parsedHref = url.parse(redirectUrl);
    replace({
      host: parsedHref.host,
      pathname: parsedHref.path,
      protocol: parsedHref.protocol,
      search: parsedHref.search,
      state: parsedHref,
    });
  }
};

export default redirect;
